import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=f8a42ade&scoped=true"
import script from "./talk.vue?vue&type=script&lang=js"
export * from "./talk.vue?vue&type=script&lang=js"
import style0 from "./talk.vue?vue&type=style&index=0&id=f8a42ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a42ade",
  null
  
)

export default component.exports